import React from 'react'
import { useSelector } from 'react-redux';
import { Modal, Button } from "react-bootstrap";
import translations from "../../assets/locals/translations";

const AlertDeleteModal = ({ showModal, hideModal, confirmModal, id, type, message, categoryd, dId }) => {
  const currentLanguage = useSelector((state) => state.language.language);
  const t = translations[currentLanguage] || translations['en'];
  return (
    <Modal id="AlertDeleteModal" show={showModal} onHide={hideModal}>
      <Modal.Header closeButton>
        <Modal.Title>{t.deleteconfirmation || 'Delete Confirmation'}</Modal.Title>
      </Modal.Header>
      <Modal.Body><div className="alert alert-danger">{message}</div></Modal.Body>
      <Modal.Footer>
        <Button variant="default" onClick={hideModal}>{t.cancel || 'Cancel'}</Button>
        <Button variant="danger" onClick={() => confirmModal(type, id, categoryd, dId)}>{t.delete || 'Delete'}</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default AlertDeleteModal;